import { ObservationLocationType } from 'libs/end-to-end/src/observation-upload-type';
import { PayCorrectionRequest } from 'libs/end-to-end/src/custom-viz/PayCorrectionTypes';
import { PayCorrectionAdjustedEmployeeSalaries } from 'libs/end-to-end/src/pay-correction/types/PayCorrectionAdjustedEmployeeSalaries';

export const constructPayCorrectionRequest = ({
  departments,
  locations,
  organizationId,
  observation,
  jobLevels,
  adjustedSalaries,
  uncheckedEmployees,
  dimension,
  metric,
}: {
  departments: string[];
  jobLevels: string[] | null;
  locations: string[];
  organizationId: string;
  observation: ObservationLocationType;
  adjustedSalaries: PayCorrectionAdjustedEmployeeSalaries;
  uncheckedEmployees: string[];
  dimension: string;
  metric: string;
}): PayCorrectionRequest => {
  const newAdjustedSalaries: PayCorrectionAdjustedEmployeeSalaries =
    Object.entries(adjustedSalaries).reduce(
      (acc, [employeeId, adjustedSalary]) => {
        if (uncheckedEmployees.includes(employeeId)) {
          return acc;
        }
        return {
          ...acc,
          [employeeId]: adjustedSalary,
        };
      },
      {},
    );

  return {
    customVizId: 'payCorrection',
    inputs: {
      dropdowns: {
        department: departments,
        job_level: departments.length === 1 ? jobLevels : null,
        location: locations,
      },
      extras: {
        adjusted_salaries: newAdjustedSalaries,
        dimension: dimension,
        metric: metric,
      },
    },
    organizationId,
    observationLocationType: observation,
  };
};
